import { render, staticRenderFns } from "./First_Aid.vue?vue&type=template&id=1b1f8744&"
import script from "./First_Aid.vue?vue&type=script&lang=js&"
export * from "./First_Aid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports